import { apiClient } from './api-client';

export interface AuthOwlflowUser {
  id: string;
  email: string;
  name: string;
  avatar?: string | null;
  role: string;
}

export interface AuthOwlflowLoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn?: string;
  user: AuthOwlflowUser;
}

interface BackendLoginResponse {
  success: boolean;
  user: AuthOwlflowUser;
  tokens: {
    accessToken: string;
    refreshToken: string;
    expiresIn?: string;
  };
}

function unwrap(raw: BackendLoginResponse): AuthOwlflowLoginResponse {
  return {
    accessToken: raw.tokens.accessToken,
    refreshToken: raw.tokens.refreshToken,
    expiresIn: raw.tokens.expiresIn,
    user: raw.user,
  };
}

export async function loginWithPassword(
  email: string,
  password: string,
): Promise<AuthOwlflowLoginResponse> {
  const { data } = await apiClient.post<BackendLoginResponse>('/api/auth/login', {
    email,
    password,
  });
  return unwrap(data);
}

export async function loginWithGoogle(
  input: { credential: string } | { accessToken: string },
): Promise<AuthOwlflowLoginResponse> {
  const body =
    'credential' in input ? { credential: input.credential } : { accessToken: input.accessToken };
  const { data } = await apiClient.post<BackendLoginResponse>('/api/auth/google', body);
  return unwrap(data);
}
